import React, { useEffect } from 'react';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { ButtonPrimary, InfoFeedbackScreen } from '@telefonica/mistica';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { FEEDBACK_CUSTOMER_VERIFICATION_TEXT_MAP } from './feedbackTextMap';

const FeedbackCustomerVerification: React.FC = () => {
    const { trackingScreenView } = new TrackingEvents();
    const { t } = useTranslation();
    const location = useLocation();
    const stateFeedbackKey =
        typeof (location.state as { feedbackKey?: unknown } | null)?.feedbackKey === 'string'
            ? ((location.state as { feedbackKey: string }).feedbackKey || '').toLowerCase()
            : '';
    const queryFeedbackKey = (new URLSearchParams(window.location.search).get('feedbackKey') || '').toLowerCase();
    const feedbackKey = stateFeedbackKey || queryFeedbackKey;
    const feedbackConfig = feedbackKey ? FEEDBACK_CUSTOMER_VERIFICATION_TEXT_MAP[feedbackKey] : undefined;

    if (!feedbackConfig) {
        return null;
    }

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='feedback-customer-verification'>
            <InfoFeedbackScreen
                title={t(feedbackConfig.titleKey)}
                description={t(feedbackConfig.descriptionKey)}
                primaryButton={
                    <ButtonPrimary
                        onPress={() => {
                            window.close();
                        }}
                    >
                        {t(feedbackConfig.primaryButtonKey)}
                    </ButtonPrimary>
                }
            />
        </div>
    );
};

export default FeedbackCustomerVerification;
